import { asCurrency, asPercentage, getAmortization, updateValuesFromFields, validateFields } from '../util'
import { useAppState } from '../Context'
import { BalanceInterestChart } from '../components/Charts'
import { AmortizationScheduleTable } from '../components/Tables'
import { InputFields } from '../components/Fields'
import CalculateResults from '../components/CalculateResults'
import CalculateRow from '../components/CalculateRow'

function PanelInput() {
  return <InputFields />
}

function PanelCalculate() {
  const { values } = useAppState()

  return (
    <CalculateResults>
      <CalculateRow>
        <div>Credit Card Balance:</div>
        <div>{asCurrency(values.balance)}</div>
      </CalculateRow>

      <CalculateRow className="font-bold">
        <div>Monthly Payment Amount:</div>
        <div>{asCurrency(values.amortization.monthlyPayment)}</div>
      </CalculateRow>

      <CalculateRow>
        <div>Number of Monthly Payments</div>
        <div>{values.numPayments}</div>
      </CalculateRow>

      <CalculateRow>
        <div>Interest Rate:</div>
        <div>{asPercentage(values.interestRate)}</div>
      </CalculateRow>

      <CalculateRow>
        <div>Total Payments:</div>
        <div>{asCurrency(values.amortization.totalPayment)}</div>
      </CalculateRow>

      <CalculateRow>
        <div>Total Interest:</div>
        <div>{asCurrency(values.amortization.totalInterest)}</div>
      </CalculateRow>
    </CalculateResults>
  )
}

function PanelChart() {
  const { values } = useAppState()

  return (
    <div className="py-4 space-y-4">
      <BalanceInterestChart amortization={values.amortization} title="Credit Card Re-Payment" />
    </div>
  )
}

function PanelDetail() {
  const { values } = useAppState()

  return <AmortizationScheduleTable amortization={values.amortization} />
}

export default {
  name: 'What payments will it take to pay off my credit cards?',
  tabs: [
    {
      name: 'Input',
      component: PanelInput,
      beforeTabChange: (dispatch, fields, values) => {
        const validate = validateFields(fields)

        if (validate.isValid) {
          const updatedValues = updateValuesFromFields(values, fields)
          const amortization = getAmortization(
            updatedValues.balance,
            updatedValues.interestRate,
            updatedValues.numPayments
          )
          dispatch({ type: 'setValues', payload: { ...updatedValues } })
          dispatch({ type: 'setValue', payload: { name: 'amortization', value: amortization } })
        }

        dispatch({ type: 'setFields', payload: validate.fields })

        return validate.isValid
      },
    },
    {
      name: 'Calculate',
      component: PanelCalculate,
    },
    {
      name: 'Chart',
      component: PanelChart,
    },
    {
      name: 'Detail',
      component: PanelDetail,
    },
  ],
  fields: [
    {
      type: 'number',
      dataType: 'float',
      displayAs: 'currency',
      name: 'balance',
      label: 'Credit Card Balance',
      value: 2000,
    },
    {
      type: 'number',
      dataType: 'int',
      name: 'numPayments',
      label: 'In How Many <strong>Months</strong> Do You Want to Repay This Card?',
      value: 12,
    },
    {
      type: 'number',
      dataType: 'float',
      displayAs: 'percent',
      name: 'interestRate',
      label: 'Interest Rate',
      value: 13,
    },
  ],
}
